import type { FilterDrawerState } from '../../types';

export function getFilterCollectionValue<T>({
	filterCollectionId,
	filter
}: {
	filterCollectionId: string;
	filter: FilterDrawerState;
}) {
	return filter[filterCollectionId]?.value as T;
}
